module.exports = __webpack_public_path__ + "img/Picture13.d337f62d.png";